import { h } from 'preact';
import { makeText, isActionAllowed } from '../../../util';
import { useEffect } from 'react';
import NeutralButtons from '../../PMTCFv2InlineNeutral/NeutralButtons';

export const StackTitle = ({
  stack,
  selected,
  toggleStack,
  language,
  settings,
  dev,
  usePurModel,
  neutralPm,
}) => {
  useEffect((e) => {
    if (usePurModel) {
      toggleStack(e, stack.categories, true, selected === 'li')
    };
  }, []);

  const counts = { active: 0, rejected: 0, neutral: 0 };
  stack.categories.forEach(c => {
    if (selected === 'consent' && c.active) {
      counts.active += 1;
    } else if (selected === 'consent' && c.active === false) {
      counts.rejected += 1;
    } else if (selected === 'consent' && c.active === null) {
      counts.neutral += 1;
    }

    if (selected === 'li' && c.legInt) {
      counts.active += 1;
    } else if (selected === 'li' && !c.legInt) {
      counts.rejected += 1;
    }
  });

  let actualStatus = 'partial';
  if (counts.active > 0 && counts.rejected === 0) actualStatus = 'accepted';
  if (counts.rejected > 0 && counts.active === 0) actualStatus = 'rejected';
  if (neutralPm) {
    if (counts.rejected === stack.categories.length) {
      actualStatus = 'rejected';
    } else if (counts.active === stack.categories.length) {
      actualStatus = 'accepted';
    } else {
      actualStatus = 'partial';
    }
  }

  let actualColor = settings.toggleOffColor;
  if (actualStatus === 'accepted') actualColor = settings.toggleColor;
  if (actualStatus === 'partial') actualColor = settings.toggleNeutralColor;

  const statusFont = { ...settings.accordionsFont };
  delete statusFont.color;
  let toggleValue = actualStatus === 'accepted' ? false : true;
  if (usePurModel) {
    actualStatus = 'accepted';
  }
  const toggleOnText = makeText(Boolean(dev), settings, 'toggleOnText', language);
  const toggleOffText = makeText(Boolean(dev), settings, 'toggleOffText', language);
  const requiredConsentLetter = makeText(Boolean(dev), settings, 'requiredConsentLetter', language);
  const hasText = toggleOnText || toggleOffText;
  const hasTextClass = hasText ? ' has-text' : '';
  const basicClassName = actualStatus === 'accepted' ? (' pm-switch checked' + hasTextClass) : (' pm-switch' + hasTextClass);
  const isToggleOn = selected === 'li' || !usePurModel ? 'inline-flex' : 'none';
  const toggle = (e) => toggleStack(e, stack.categories, toggleValue, selected === 'li');
  const neutralPmToggle = (e, value) => toggleStack(e, stack.categories, value, false);
  const requireConsent = stack.categories.some(c => c.requireConsent)
  
  return (
    <div className="stack-title" style={{ display: neutralPm && 'flex' }}>
      <h4 style={{ ...settings.accordionsFont}}>
        {stack.name}
        {requireConsent && (
          <span className="legend-key inline required-consent" aria-hidden>
            {requiredConsentLetter}
          </span>
        )}
      </h4>
      {!neutralPm && (
          <label
            className={'pm-nswitch ' + actualStatus + basicClassName}
            onKeyDown={e => isActionAllowed(e.key) && toggle(e)}
            style={{ display: isToggleOn }}
          >
            <span
              tabIndex="0"
              className={actualStatus === 'accepted' ? 'slider round is-checked' : 'slider round'}
              style={{ backgroundColor: actualColor }}
              onClick={toggle}
            >{actualStatus === 'partial' ? null : (actualStatus === 'accepted' ? toggleOnText : toggleOffText)}</span>
          </label>
        )}
    </div>
  );
};